import { type ReactNode, useEffect, useRef } from "react";

export const AuthScreen = ({
  children,
  eyebrow,
  subtitle,
  title,
}: {
  children?: ReactNode;
  eyebrow?: string;
  subtitle: ReactNode;
  title: string;
}) => {
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-2">
        {eyebrow ? (
          <p className="mb-1 font-semibold text-coral-700 text-xs uppercase tracking-[0.12em]">
            {eyebrow}
          </p>
        ) : null}
        <h1
          className="font-semibold text-[32px] leading-[1.1] tracking-[-0.02em] outline-none"
          ref={headingRef}
          tabIndex={-1}
        >
          {title}
        </h1>
        <p className="text-base text-n-600 leading-[1.55]">{subtitle}</p>
      </div>
      {children}
    </div>
  );
};
